export const view_types  = {
  new: 'new',
  soi: 'soi',
  doi: 'doi'
}
